// @flow
import type { Request } from '../../../index';

type UrlParams = {
  orgId: number | string,
  complexId: number | string,
}

type ComplexRestoreResult = 'success'

export const POST_COMPLEX_RESTORE: Request<
  void,
  ComplexRestoreResult,
  UrlParams
> = [
  'food/schools/{orgId}/complexes/{complexId}/restore',
  'post',
  ['data', 'result'],
];
